import React, { Fragment } from 'react';
import lodash from 'lodash';
import InputField from 'components/common/Study/InputField';
import Input from 'components/common/Input/FormInput';
import styles from './StudyMonitorForm.scss';

export default function StudyMonitorForm(props) {
    const {
        externalUser: { firstName, lastName, emailAddress, startDate, startTime, endDate, endTime, notify } = {},
        externalUser,
        endDateIsValid,
        endTimeIsValid,
        isExistingExternalUser,
        updateExternalUserInputs,
    } = props;

    const updateFieldValue = (e) => {
        const { target: { name, value } = {} } = e || {};
        updateExternalUserInputs(name, value);
    };

    const isValid = name => !lodash.isEmpty(externalUser[name]);

    const toggle = () => {
        updateFieldValue({ target: { name: 'notify', value: !notify } });
    };

    return (
        <Fragment data-cy="StudyMonitorForm">
            <Field
                label='Email Address'
                value={emailAddress}
            />
            {isExistingExternalUser
                ? < Fragment >
                    <Field
                        label='First Name'
                        value={firstName}
                    />
                    <Field
                        label='Last Name'
                        value={lastName}
                    />
                </Fragment>
                : <Fragment>
                    <InputField
                        required={false}
                    >
                        <Input
                            title='First Name'
                            value={firstName}
                            name='firstName'
                            placeholder='Enter First Name'
                            required
                            isValid={isValid.bind(null, 'firstName')}
                            errorText='Please Provide a First Name'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            className='weighted'
                            data-cy="StudyMonitorForm-onChange"
                        />
                    </InputField>
                    <InputField
                        required={false}
                    >
                        <Input
                            title='Last Name'
                            value={lastName}
                            name='lastName'
                            placeholder='Enter Last Name'
                            required
                            isValid={isValid.bind(null, 'lastName')}
                            errorText='Please Provide a Last Name'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            className='weighted'
                            data-cy="StudyMonitorForm-lastName"
                        />
                    </InputField>
                </Fragment>
            }
            <InputField
                required={false}
                helperText={'Start the monitor\'s window of access to this study.'}
                data-cy="StudyMonitorForm-InputField"
            >
                <Input
                    title='Select Start Date'
                    value={startDate}
                    name='startDate'
                    placeholder='Select Start Date'
                    type='date'
                    required
                    isValid={isValid.bind(null, 'startDate')}
                    errorText='Please Provide a Start Date'
                    onBlur={updateFieldValue}
                    onChange={updateFieldValue}
                    withBackground
                    data-cy="StudyMonitorForm-startDate"
                />
            </InputField>
            <InputField
                required={false}
            >
                <Input
                    title='Select Start Time (Institution Timezone)'
                    value={startTime}
                    name='startTime'
                    placeholder='Select Start Time'
                    type='time'
                    required
                    isValid={isValid.bind(null, 'startTime')}
                    errorText='Please Provide a Start Time'
                    onBlur={updateFieldValue}
                    onChange={updateFieldValue}
                    withBackground
                    data-cy="StudyMonitorForm-startTime"
                />
            </InputField>
            <InputField
                required={false}
                helperText={'End the monitor\'s window of access to this study.'}
            >
                <Input
                    title='Select End Date'
                    value={endDate}
                    name='endDate'
                    placeholder='Select End Date'
                    type='date'
                    min={startDate}
                    isValid={endDateIsValid}
                    errorText='End Date cannot be earlier than Start Date'
                    onBlur={updateFieldValue}
                    onChange={updateFieldValue}
                    withBackground
                    data-cy="StudyMonitorForm-endDate"
                />
            </InputField>
            <InputField
                required={false}
            >
                <Input
                    title='Select End Time (Institution Timezone)'
                    value={endTime}
                    name='endTime'
                    placeholder='Select End Time'
                    type='time'
                    isValid={endTimeIsValid}
                    errorText='End Time must be after the Start Time on the same day'
                    onBlur={updateFieldValue}
                    onChange={updateFieldValue}
                    withBackground
                    data-cy="StudyMonitorForm-endTime"
                />
            </InputField>
            <Checkbox
                notify={notify}
                toggle={toggle}
                data-cy="StudyMonitorForm-Checkbox"
            >
                Notify user about study access
            </Checkbox>
        </Fragment>
    );
}

const Field = ({ label, value }) => (
    <div className={styles.wrapper}>
        <h2 className={styles.label}>{label} </h2>
        <h3 className={styles.label}>{value} </h3 >
    </div>
);

const Checkbox = props => (
    <div
        className={styles.checkbox}
        onClick={props.toggle}
        value={props.notify}
        data-cy="StudyMonitorForm-Checkboxs"
    >
        <i className={styles.checkboxIcon}>
            {props.notify
                ? 'check_box'
                : 'check_box_outline_blank'
            }
        </i>
        <p data-cy="StudyMonitorForm-children">
            {props.children}
        </p>
    </div>
);
